export * from './kmc-server-polls.service';
export * from './kmc-server-polls.module';
